// File: src/components/AppLayout.tsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SidebarNav } from './SidebarNav';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

export function AppLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isWideLayoutPage = location.pathname === '/suppliers/invoices/new' || location.pathname === '/sales' || location.pathname === '/debtors';

  // Handle responsive sidebar behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    
    // Set initial state
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(open => !open);
  };

  return (
    <div className="h-screen overflow-hidden flex bg-gray-50 dark:bg-gray-900">
      {/* Mobile toggle */}
      <div className="lg:hidden fixed top-4 left-4 z-40">
        <Button
          variant="outline"
          size="icon"
          onClick={toggleSidebar}
          className="rounded-xl h-12 w-12 bg-white/95 backdrop-blur-sm shadow-lg border-slate-200 hover:bg-white text-slate-700 hover:text-slate-900"
        >
          {sidebarOpen ? <X size={20} className="text-slate-700" /> : <Menu size={20} className="text-slate-700" />}
        </Button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed lg:static z-30 transform transition-transform duration-300 ease-in-out h-screen shrink-0
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        <SidebarNav />
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 backdrop-blur-sm z-20 transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <main className={`flex-1 min-w-0 h-screen overflow-hidden transition-all duration-300 ${sidebarOpen ? 'lg:ml-0' : ''}`}>
        <div className="h-full overflow-y-auto">
          <div className="p-4 pt-20 lg:pt-4 lg:p-8">
            <div className={isWideLayoutPage ? 'w-full' : 'max-w-7xl mx-auto'}>
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
